import { isObject, isNumber, isString } from 'ldash';
import { AuthError, NotfoundError, TimeoutError } from 'uix/error';
export const isProblemDocument = (data)=>isObject(data) && isString(data.type) && isNumber(data.status) && isString(data.detail) && isString(data.code);
export const problemError = (url, problem, timeout)=>{
    let { status, detail, code } = problem;
    let error;
    if (code === 'api_timeout') {
        error = new TimeoutError(url, timeout, detail);
    } else if (status === 401 || status === 403) {
        error = new AuthError(url, status, problem.i18nReason || problem.reason || 'Auth Error', detail);
    } else if (status === 404) {
        error = new NotfoundError(url, detail);
    } else {
        error = new Error(detail);
        error.name = problem.title || 'ApiError';
        error.code = code || 'E_API';
    }
    error.status = status;
    error.url = url;
    error.error = code;
    error.errorMsg = detail;
    error.problem = problem;
    if (problem.traceback) {
        error.traceback = problem.traceback;
    }
    return error;
};
